var _excluded = ["classsName", "value", "indent"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import classNames from 'classnames';
import './fancy-text.less';

var FancyText = /*#__PURE__*/function (_React$Component) {
  _inherits(FancyText, _React$Component);

  var _super = _createSuper(FancyText);

  function FancyText() {
    var _this;

    _classCallCheck(this, FancyText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderValue", function (value) {
      var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (value === undefined) {
        return /*#__PURE__*/React.createElement("span", {
          className: "value-undefined"
        }, "undefined");
      } else if (value === null) {
        return /*#__PURE__*/React.createElement("span", {
          className: "value-null"
        }, "null");
      } else if (Array.isArray(value)) {
        return /*#__PURE__*/React.createElement("ul", {
          className: "value-array"
        }, value.map(function (item) {
          return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FancyText, {
            value: item,
            indent: indent + 1
          }));
        }));
      } else if (_typeof(value) === 'object') {
        return /*#__PURE__*/React.createElement("ul", {
          className: "value-object"
        }, Object.keys(value).map(function (key) {
          return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
            style: {
              marginLeft: "".concat(indent * 12, "px")
            },
            className: "value-object-key"
          }, key, ":"), /*#__PURE__*/React.createElement(FancyText, {
            value: value[key],
            indent: indent + 1
          }));
        }));
      }

      var components = [];
      extractJson(value.toString()).forEach(function (possibleJson) {
        if (possibleJson.isJson) {
          components.push( /*#__PURE__*/React.createElement(FancyText, {
            value: possibleJson.parsed,
            indent: indent + 1
          }));
          return;
        }

        extratHtml(possibleJson.text).forEach(function (possibleHtml) {
          if (possibleHtml.isHtml) {
            components.push( /*#__PURE__*/React.createElement("iframe", {
              style: {
                display: 'block',
                width: '100%',
                border: 'none'
              },
              ref: function ref(iframe) {
                if (!iframe) {
                  return;
                }

                var root = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                root.document.open();
                root.document.write(possibleHtml.text);
                root.document.close();
                iframe.style.height = "".concat(root.document.body.scrollHeight + 24, "px");
              }
            }));
            return;
          }

          extractLinks(possibleHtml.text).forEach(function (possibleLink) {
            if (possibleLink.isLink) {
              components.push( /*#__PURE__*/React.createElement("a", {
                href: possibleLink.text,
                target: "_blank"
              }, " ".concat(possibleLink.text, " ")));
              return;
            }

            components.push( /*#__PURE__*/React.createElement("span", null, possibleLink.text));
          });
        });
      });
      return /*#__PURE__*/React.createElement(Fragment, null, components);
    });

    return _this;
  }

  _createClass(FancyText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classsName = _this$props.classsName,
          value = _this$props.value,
          indent = _this$props.indent,
          props = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("span", _extends({}, props, {
        className: classNames('fancy-text', classsName)
      }), this.renderValue(value, indent));
    }
  }]);

  return FancyText;
}(React.Component);

export { FancyText as default };

function extractJson(value) {
  var results = [];
  var current = [];
  var inJson = 0;
  var inQuote = 0;

  for (var i = 0; i < value.length; i++) {
    if (inJson) {
      if (inQuote && value[i] === '"' && value[i - 1] !== '\\') {
        inQuote -= 1;
      } else if (!inQuote && value === '"') {
        inQuote += 1;
      } else if (!inQuote && value[i] === '{') {
        inJson += 1;
      } else if (!inQuote && value[i] === '}') {
        inJson -= 1;

        if (!inJson) {
          current.push('}');
          results.push({
            isJson: true,
            text: current.join('')
          });
          current = [];
        }
      } else {
        current.push(value[i]);
      }
    } else if (value[i] === '{') {
      if (current.length > 0) {
        results.push({
          isJson: false,
          text: current.join('')
        });
      }

      inJson += 1;
      current = ['{'];
    } else {
      current.push(value[i]);
    }
  }

  if (current.length > 0) {
    results.push({
      isJson: false,
      text: current.join('')
    });
  } // parse any json to make sure it's valid


  var parsedResults = [];
  results.forEach(function (possibleJson) {
    if (possibleJson.isJson) {
      try {
        possibleJson.parsed = JSON.parse(possibleJson.text);
      } catch (_unused) {
        possibleJson.isJson = false;
      }
    } // combine any non json results if they are consecutive


    if (possibleJson.isJson) {
      parsedResults.push(possibleJson);
    } else if (parsedResults.length === 0 || parsedResults[parsedResults.length - 1].isJson) {
      parsedResults.push(possibleJson);
    } else {
      parsedResults[parsedResults.length - 1].text = "".concat(parsedResults[parsedResults.length - 1].text, " ").concat(possibleJson.text);
    }
  });
  return parsedResults;
}

function extratHtml(value) {
  var results = [];
  var current = [];
  var inHtml = 0;
  value.split(' ').forEach(function (word) {
    if (!word) {
      return;
    }

    if (inHtml) {
      if (word.toLowerCase().indexOf('</html>') >= 0) {
        var endIndex = word.toLowerCase().indexOf('</html>');
        inHtml -= 1;
        current.push(word.substring(0, endIndex + 7));
        results.push({
          isHtml: true,
          text: current.join(' ')
        });
        current = [];
        var extraWord = word.substring(endIndex + 7);

        if (extraWord) {
          current.push(extraWord);
        }
      } else {
        current.push(word);
      }
    } else if (word.toLowerCase().indexOf('<!doctype') === 0 || word.toLowerCase().indexOf('<html>') === 0) {
      inHtml += 1;

      if (current.length > 0) {
        results.push({
          isHtml: false,
          text: current.join(' ')
        });
      }

      if (word.toLowerCase().indexOf('</html>') >= 0) {
        var _endIndex = word.toLowerCase().indexOf('</html>');

        results.push({
          isHtml: true,
          text: word.substring(0, _endIndex + 7)
        });
        current = [];

        var _extraWord = word.substring(_endIndex + 7);

        if (_extraWord) {
          current.push(_extraWord);
        }
      } else {
        current = [word];
      }
    } else {
      current.push(word);
    }
  });

  if (current.length > 0) {
    results.push({
      isHtml: false,
      text: current.join(' ')
    });
  }

  return results;
}

function extractLinks(value) {
  var results = [];
  var current = [];
  value.split(' ').forEach(function (word) {
    if (!word) {
      return;
    }

    if (word.toLowerCase().indexOf('http://') === 0 || word.toLowerCase().indexOf('https://') === 0) {
      if (current.length > 0) {
        results.push({
          isLink: false,
          text: current.join(' ')
        });
      }

      results.push({
        isLink: true,
        text: word
      });
    } else {
      current.push(word);
    }
  });

  if (current.length > 0) {
    results.push({
      isLink: false,
      text: current.join(' ')
    });
  }

  return results;
}
//# sourceMappingURL=fancy-text.js.map